export default __webpack_public_path__ + "_/images/marketplace/slot-cloak-63ac082a416a177ff58404762a42b6e99d830b9d9a7b15767dbf4c44cb48abbb.png";